<template>
    <div class="bidder-child-page">
        <div class="page-header">
            <div class="page-header-content">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title">响应文件</h2>
            </div>
            <div class="header-action">
                <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
            </div>
        </div>
        <!-- 内容区 -->
        <div class="content-container">
            <!-- 公司信息卡片 -->
            <div class="info-card">
                <div class="card-header">
                    <i class="el-icon-office-building"></i>
                    <h3 class="card-title">公司信息</h3>
                </div>
                <div class="card-body">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="info-item-row">
                                <label class="info-label">投标人名称</label>
                                <div class="info-value">{{ companyInfo.userName || '-' }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 上传投标文件卡片 -->
            <div class="info-card"       v-if="infoData.status == 0" >
                <div class="card-header">
                    <i class="el-icon-upload"></i>
                    <h3 class="card-title">上传投标文件</h3>
                </div>
                <div class="card-body">
                    <input ref="bidDocInput" type="file" style="display:none" accept=".zip"
                        @change="handleBidDocSelect" />
                    <template v-if="!bidDocFile">
                        <div class="upload-trigger" @click="selectBidDoc">
                            <i class="el-icon-upload2 upload-trigger-icon"></i>
                            <p class="upload-trigger-title">{{ bidDocUploading ? '上传中...' : '点击上传投标文件' }}</p>
                            <p class="upload-trigger-hint">请使用 <strong>诚易招.exe</strong> 文件制作工具在本地生成zip格式的投标文件后，在此处上传</p>
                            <p class="upload-trigger-hint upload-trigger-hint--warn">建议文件大小不超过 1GB，超过 1GB 可能影响上传速度</p>
                        </div>
                    </template>
                    <template v-else>
                        <div class="upload-file-item">
                            <i class="el-icon-document upload-file-icon"></i>
                            <span class="upload-file-name">{{ bidDocFile.fileName }}</span>
                            <el-progress v-if="bidDocUploadProgress < 100" :percentage="bidDocUploadProgress"
                                class="upload-file-progress" />
                            <el-tag v-else type="success" size="small">已上传</el-tag>
                            <el-button type="text" class="upload-file-remove" @click="removeBidDoc">
                                <i class="el-icon-delete"></i>移除
                            </el-button>
                        </div>
                    </template>
                </div>
            </div>
            <div class="info-card" v-else>
                <div class="card-header">
                    <i class="el-icon-circle-check" style="color: #67c23a;"></i>
                    <h3 class="card-title">已上传投标文件</h3>
                    <el-tag type="success" size="small">已递交</el-tag>
                </div>
            </div>
            <!-- 下载相关文件卡片 -->
            <div class="info-card" v-if="infoData.mainFileUrl || infoData.blindMainFileUrl || (infoData.attUrls && infoData.attUrls.length)">
                <div class="card-header">
                    <i class="el-icon-folder-opened"></i>
                    <h3 class="card-title">文件查看下载</h3>
                </div>
                <div class="card-body">
                    <div class="file-list">
                        <div class="file-item" v-if="infoData.mainFileUrl">
                            <div class="file-icon-wrap">
                                <i class="el-icon-document file-icon"></i>
                            </div>
                            <div class="file-info">
                                <div class="file-name">明标正文</div>
                            </div>
                            <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownload(infoData.mainFileUrl, '明标正文.pdf')">点击下载</el-button>
                        </div>
                        <div class="file-item" v-if="infoData.blindMainFileUrl">
                            <div class="file-icon-wrap">
                                <i class="el-icon-document file-icon"></i>
                            </div>
                            <div class="file-info">
                                <div class="file-name">暗标正文</div>
                            </div>
                            <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownload(infoData.blindMainFileUrl, '暗标正文.pdf')">点击下载</el-button>
                        </div>
                        <div class="file-item" v-for="(item, index) in (infoData.attUrls || [])" :key="index">
                            <div class="file-icon-wrap">
                                <i class="el-icon-paperclip file-icon"></i>
                            </div>
                            <div class="file-info">
                                <div class="file-name">{{ getDownloadFileName(item, '附件' + (index + 1)) }}</div>
                            </div>
                            <el-button type="primary" size="small" icon="el-icon-download" @click="handleDownload(item, getDownloadFileName(item, '附件' + (index + 1)))">点击下载</el-button>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 投标信息卡片 -->
            <div class="info-card" v-if="uploadedBidFile.fileId !== ''">
                <div class="card-header">
                    <i class="el-icon-document-checked"></i>
                    <h3 class="card-title">投标信息</h3>
                </div>
                <div class="card-body">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <div class="info-item-row">
                                <label class="info-label">投标文件</label>
                                <div class="info-value file-name">
                                    <i class="el-icon-document"></i>
                                    {{ uploadedBidFile.fileName || '-' }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item-row">
                                <label class="info-label">递交截止时间</label>
                                <div class="info-value">
                                    <i class="el-icon-time"></i>
                                    {{ uploadedBidFile.deadline || '-' }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="info-item-row">
                                <label class="info-label">当前时间</label>
                                <div class="info-value">
                                    <i class="el-icon-time"></i>
                                    {{ uploadedBidFile.currentTime || '-' }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <!-- <el-row :gutter="20" class="info-row spacing-top">
                        <el-col :span="12">
                            <div class="info-item-row">
                                <label class="info-label">投标文件编号</label>
                                <div class="info-value code">
                                    <i class="el-icon-tickets"></i>
                                    {{ uploadedBidFile.fileId }}
                                </div>
                            </div>
                        </el-col>
                    </el-row> -->
                </div>
            </div>
            <!-- 项目负责人信息卡片 -->
            <div class="info-card">
                <div class="card-header">
                    <i class="el-icon-user"></i>
                    <h3 class="card-title">项目负责人信息</h3>
                </div>
                <div class="card-body">
                    <!-- <div class="info-notice">
                        <i class="el-icon-info"></i>
                        <span>请填写项目负责人相关信息，标记 * 的为必填项</span>
                    </div> -->
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="form-field">
                                <label class="field-label required">项目负责人姓名</label>
                                <el-input v-model="projectManager.name" placeholder="请输入姓名" prefix-icon="el-icon-user"
                                    clearable>
                                </el-input>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="form-field">
                                <label class="field-label required">项目负责人手机号</label>
                                <el-input v-model="projectManager.phone" placeholder="请输入手机号"
                                    prefix-icon="el-icon-phone" clearable>
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="form-field">
                                <label class="field-label required">项目负责人身份证号</label>
                                <el-input v-model="projectManager.pmIdNo" placeholder="请输入身份证号"
                                    prefix-icon="el-icon-postcard" clearable maxlength="18">
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
            <!-- 操作按钮 -->
            <div class="action-footer">
                <el-button type="success" size="large" icon="el-icon-document" @click="handleViewReceipt"
                    v-if="infoData.status == 1">
                    查看回执
                </el-button>
                <el-button type="success" size="large" icon="el-icon-document" @click="uploadBidDocument"
                    v-if="infoData.status == 0" :disabled="!uploadFileId">
                    递交投标文件
                </el-button>
                <el-button type="warning" size="large" icon="el-icon-refresh-left" @click="handleWithdraw"
                    v-if="infoData.status == 1 &&infoData.mainFileUrl=='' || infoData.mainFileUrl==null">
                    撤回投标
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { getUploadDocumentDetail, uploadBidDocument, updateBidDocument, downloadReceiptPdf, revokeBidDocument,uploadBidDocumentInfo } from '@/api/modules/tenderNotice'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import { deleteBidAtt } from '@/api/modules/make'
import JSZip from 'jszip'
import Cookies from 'js-cookie'
import { timeUtils } from '@/utils/base'
import { getBidderFlowTitle } from '@/utils/bid/projectInfo'

export default {
    name: 'BidDocument',
    data() {
        return {
            infoData: {},
            bidInfo:{},
            sectionCode: this.$route.query.sectionCode || '',
            projectInfo: {
                projectNumber: this.$route.query.projectNumber || '',
                projectName: this.$route.query.projectName || '',
                bidSectionCode: '',
                bidSectionName: ''
            },
            companyInfo: {
                userName: ''
            },
            uploadedBidFile: {
                fileName: '',
                fileId: '',
                deadline: '',
                currentTime: ''
            },
            projectManager: {
                name: '',
                phone: '',
                pmIdNo: ''
            },
            uploadFileId: '',
            fileBindId: String(new Date().getTime()) + Math.random().toString().substr(2, 5),
            bidDocUploading: false,
            bidDocUploadProgress: 0,
            bidDocFile: null
        }
    },
    mounted() {
        this.getUploadDocumentDetail()
        this.getProjectInfo()
    },
    methods: {
        // 获取项目信息
        async getProjectInfo() {
            this.projectTitle = await getBidderFlowTitle(this.sectionCode);
        },
        // 获取投标文件上传详情
        getUploadDocumentDetail() {
            getUploadDocumentDetail({
                sectionCode: this.sectionCode
            }).then(res => {
                if (res && res.data) {
                    const data = res.data
                    this.infoData = data;
                    // 更新项目信息
                    if (data.projectCode) {
                        this.projectInfo.projectNumber = data.projectCode
                    }
                    if (data.projectName) {
                        this.projectInfo.projectName = data.projectName
                    }
                    if (data.sectionCode) {
                        this.projectInfo.bidSectionCode = data.sectionCode
                    }
                    if (data.sectionName) {
                        this.projectInfo.bidSectionName = data.sectionName
                    }
                    // 更新公司信息 - 投标人名称
                    if (data.bidderName) {
                        this.companyInfo.userName = data.bidderName
                    }
                    // 更新投标文件信息
                    if (data.fileId !== null && data.fileId !== undefined) {
                        this.uploadedBidFile.fileId = data.fileId
                    }
                    if (data.fileName !== null && data.fileName !== undefined) {
                        this.uploadedBidFile.fileName = data.fileName
                    }
                    if (data.deadline !== null && data.deadline !== undefined) {
                        this.uploadedBidFile.deadline = data.deadline
                    }
                    // 更新当前时间（如果有截止时间，可以使用截止时间，否则使用当前时间）
                    if (data.deadline) {
                        this.uploadedBidFile.currentTime = timeUtils.getCurrentTime()
                    }
                    // 更新项目负责人信息
                    if (data.projectManagerInfo) {
                        const pmInfo = data.projectManagerInfo
                        if (pmInfo.pmName) {
                            this.projectManager.name = pmInfo.pmName
                        }
                        if (pmInfo.pmPhone) {
                            this.projectManager.phone = pmInfo.pmPhone
                        }
                        if (pmInfo.pmIdNo) {
                            this.projectManager.pmIdNo = pmInfo.pmIdNo
                        }
                    }
                }
            }
            ).catch(error => {
                console.log(error)
                this.$message.error('获取文件信息失败')
            })
        },
        // 递交投标文件
        uploadBidDocument() {
            if (this.infoData.isOnline == 0 && !this.uploadFileId) {
                this.$message.warning('请先上传投标文件')
                return
            }
            if (!this.projectManager.name) {
                this.$message.warning('请填写项目负责人姓名')
                return
            }
            if (!this.projectManager.phone) {
                this.$message.warning('请填写项目负责人手机号')
                return
            }
            const phone = String(this.projectManager.phone).trim()
            const phoneReg = /^1\d{10}$/
            if (!phoneReg.test(phone)) {
                this.$message.warning('请输入正确的11位手机号')
                return
            }
            if (!this.projectManager.pmIdNo) {
                this.$message.warning('请填写项目负责人身份证号')
                return
            }
            const idNo = String(this.projectManager.pmIdNo).trim()
            const idNoReg = /(^\d{15}$)|(^\d{17}([0-9]|X|x)$)/
            if (!idNoReg.test(idNo)) {
                this.$message.warning('请输入正确的身份证号')
                return
            }
            const params = {
                sectionCode: this.sectionCode || '',
                pmName: this.projectManager.name || '',
                pmPhone: phone,
                pmIdNo: idNo,
                fileId: this.fileBindId
            }
            params.uploadFileId = this.uploadFileId
            uploadBidDocument(params).then(res => {
                if (res && res.code === 200) {
                    this.$message.success('提交成功')
                    this.getUploadDocumentDetail()
                } else {
                    this.$message.error(res.msg)
                }
            }).catch(error => {
                console.error(error)
                this.$message.error('提交失败')
            })

        },
        // 触发文件选择
        selectBidDoc() {
            if (this.bidDocUploading) {
                this.$message.warning('请等待当前文件上传完成')
                return
            }
            this.$refs.bidDocInput.click()
        },
        // 文件选中后上传
        async handleBidDocSelect(event) {
            const file = event.target.files[0]
            if (!file) return
            const fileExt = '.' + file.name.split('.').pop().toLowerCase()
            if (fileExt !== '.zip') {
                this.$message.error('仅支持上传由诚易招.exe生成的 zip 格式投标文件')
                event.target.value = ''
                return
            }
            const warnSize = 1 * 1024 * 1024 * 1024
            if (file.size > warnSize) {
                this.$message.warning('文件超过 1GB，上传时间可能较长，请耐心等待')
            }
            this.bidDocFile = { fileName: file.name }
            this.bidDocUploading = true
            this.bidDocUploadProgress = 0

            try {
                let bidInfo = null
                try {
                    // 1. 首选使用流式/切片解析（无内存分配瓶颈，支持 10GB 以上超大压缩包秒级解析）
                    bidInfo = await this.parseZipSlicing(file)
                } catch (sliceErr) {
                    console.warn('流式切片解析失败，尝试降级使用 JSZip 解析整个文件:', sliceErr)
                    // 2. 降级：使用标准 JSZip 解析（对于 1GB 以上文件有可能会由于浏览器 ArrayBuffer 限制而分配内存失败）
                    const zip = new JSZip()
                    const zipContent = await zip.loadAsync(file)
                    const bidInfoKey = Object.keys(zipContent.files).find(name => name.endsWith('bid_info.json'))
                    if (bidInfoKey) {
                        const jsonText = await zipContent.files[bidInfoKey].async('text')
                        bidInfo = JSON.parse(jsonText)
                    }
                }

                if (!bidInfo) {
                    this.$message.error('上传失败：未在压缩包中检测到有效的 bid_info.json 配置文件！')
                    event.target.value = ''
                    this.bidDocFile = null
                    this.bidDocUploading = false
                    return
                }

                this.bidInfo = bidInfo
                const zipSectionCode = this.bidInfo.sectionCode ? String(this.bidInfo.sectionCode).trim() : ''
                const zipUserId = (this.bidInfo.userId || this.bidInfo.userid) ? String(this.bidInfo.userId || this.bidInfo.userid).trim() : ''
                const loginUserId = Cookies.get('userId') ? String(Cookies.get('userId')).trim() : ''
                const currentSectionCode = this.sectionCode ? String(this.sectionCode).trim() : ''
                // 1. 校验标段编号是否一致
                if (zipSectionCode !== currentSectionCode) {
                    this.$message.error(`上传失败：标段不一致，无法上传！`)
                    event.target.value = ''
                    this.bidDocFile = null
                    this.bidDocUploading = false
                    return
                }
                // 2. 校验用户ID是否一致
                if (zipUserId && loginUserId && zipUserId !== loginUserId) {
                    this.$message.error('上传失败：该投标文件的所属账号与当前登录账号不一致，无法上传！')
                    event.target.value = ''
                    this.bidDocFile = null
                    this.bidDocUploading = false
                    return
                }
            } catch (err) {
                console.error('前端解析 ZIP 失败:', err)
                let errMsg = '上传失败：解析 ZIP 配置文件出错，文件可能损坏！'
                if (err && (err.name === 'NotReadableError' || String(err).includes('NotReadableError'))) {
                    errMsg = '上传失败'
                }
                this.$message.error(errMsg)
                event.target.value = ''
                this.bidDocFile = null
                this.bidDocUploading = false
                return
            }

            try {
                const result = await doFileUpload(file, {
                    fileBindId: this.fileBindId,
                    onProgress: (percentage) => {
                        this.bidDocUploadProgress = Math.floor(percentage)
                    }
                })
                if (!result.success) throw new Error(result.message || '上传失败')
                
                // 组装并递交投标文件关联的项目相关解密及设备信息
                const infoParams = {
                    certId: this.bidInfo.certId || '',
                    encryptedKey: this.bidInfo.encryptedKey || '',
                    macAddress: this.bidInfo.macAddress || '',
                    sectionCode: this.sectionCode || this.bidInfo.sectionCode || '',
                    certName: this.bidInfo.certName || ''
                }
                const infoRes = await uploadBidDocumentInfo(infoParams)
                if (infoRes.code !== 200) {
                    throw new Error(infoRes.msg )
                }

                this.uploadFileId = result.uploadFileId || result.fileId || ''
                this.bidDocFile = { fileName: file.name, filePath: result.filePath, fileId: result.fileId || '' }
                this.bidDocUploadProgress = 100
                this.$message.success('文件上传及项目信息递交成功')
            } catch (error) {
                this.$message.error(error.message || '文件上传失败')
                this.bidDocFile = null
                this.uploadFileId = ''
                this.bidDocUploadProgress = 0
            } finally {
                this.bidDocUploading = false
                event.target.value = ''
            }
        },
        // 通过文件切片（Slicing）极速解析 ZIP/ZIP64 中的 bid_info.json，支持 10GB 以上超大文件，内存占用极低（< 1MB）
        async parseZipSlicing(file) {
            const endSliceSize = Math.min(file.size, 65536)
            const endBlob = file.slice(file.size - endSliceSize)
            const endBuffer = await endBlob.arrayBuffer()
            const endView = new DataView(endBuffer)
            
            let eocdOffset = -1
            for (let i = endBuffer.byteLength - 22; i >= 0; i--) {
                if (endView.getUint32(i, true) === 0x06054b50) {
                    eocdOffset = i
                    break
                }
            }
            if (eocdOffset === -1) {
                throw new Error('无法定位 ZIP 结束标识符（EOCD）')
            }
            
            const actualEocdOffset = file.size - endSliceSize + eocdOffset
            let cdSize = endView.getUint32(eocdOffset + 12, true)
            let cdOffset = endView.getUint32(eocdOffset + 16, true)
            let isZip64 = false
            let zip64EocdOffset = -1
            
            // 兼容 ZIP64 格式 (超大文件标配，大小/偏移为 0xFFFFFFFF)
            if (cdOffset === 0xFFFFFFFF || cdSize === 0xFFFFFFFF) {
                let zip64LocatorOffset = -1
                for (let i = eocdOffset - 20; i >= 0; i--) {
                    if (endView.getUint32(i, true) === 0x07064b50) {
                        zip64LocatorOffset = i
                        break
                    }
                }
                if (zip64LocatorOffset !== -1) {
                    const locatorAbsoluteOffset = file.size - endSliceSize + zip64LocatorOffset
                    const absoluteZip64EocdOffset = Number(endView.getBigUint64(zip64LocatorOffset + 8, true))
                    const zip64EocdBlob = file.slice(absoluteZip64EocdOffset, absoluteZip64EocdOffset + 56)
                    const zip64EocdBuffer = await zip64EocdBlob.arrayBuffer()
                    const zip64EocdView = new DataView(zip64EocdBuffer)
                    if (zip64EocdView.getUint32(0, true) === 0x06064b50) {
                        cdSize = Number(zip64EocdView.getBigUint64(40, true))
                        cdOffset = Number(zip64EocdView.getBigUint64(48, true))
                        zip64EocdOffset = absoluteZip64EocdOffset
                        isZip64 = true
                    }
                }
            }
            
            // 计算自适应偏移差值 (Shift)
            // 部分客户端或 SFX 会在 ZIP 文件头前填充字节，这就产生了绝对位移与相对位移的偏差
            const actualCdEndOffset = isZip64 ? zip64EocdOffset : actualEocdOffset
            const actualCdOffset = actualCdEndOffset - cdSize
            const shift = actualCdOffset - cdOffset
            
            const realCdOffset = cdOffset + shift
            const cdBlob = file.slice(realCdOffset, realCdOffset + cdSize)
            const cdBuffer = await cdBlob.arrayBuffer()
            const cdView = new DataView(cdBuffer)
            
            let offset = 0
            let fileHeaderOffset = -1
            let compressedSize = 0
            let uncompressedSize = 0
            let compressionMethod = 0
            
            while (offset < cdBuffer.byteLength) {
                if (cdView.getUint32(offset, true) !== 0x02014b50) {
                    break
                }
                const method = cdView.getUint16(offset + 10, true)
                let compSize = cdView.getUint32(offset + 20, true)
                let uncompSize = cdView.getUint32(offset + 24, true)
                const nameLen = cdView.getUint16(offset + 28, true)
                const extraLen = cdView.getUint16(offset + 30, true)
                const commentLen = cdView.getUint16(offset + 32, true)
                let localHeaderOffset = cdView.getUint32(offset + 42, true)
                
                // 兼容 ZIP64 字段级的大文件 64 位值解析
                if (localHeaderOffset === 0xFFFFFFFF || compSize === 0xFFFFFFFF || uncompSize === 0xFFFFFFFF) {
                    let extraOffset = offset + 46 + nameLen
                    const extraEnd = extraOffset + extraLen
                    while (extraOffset + 4 <= extraEnd) {
                        const headerId = cdView.getUint16(extraOffset, true)
                        const dataSize = cdView.getUint16(extraOffset + 2, true)
                        if (headerId === 0x0001) {
                            let zip64Offset = extraOffset + 4
                            if (uncompSize === 0xFFFFFFFF) {
                                uncompSize = Number(cdView.getBigUint64(zip64Offset, true))
                                zip64Offset += 8
                            }
                            if (compSize === 0xFFFFFFFF) {
                                compSize = Number(cdView.getBigUint64(zip64Offset, true))
                                zip64Offset += 8
                            }
                            if (localHeaderOffset === 0xFFFFFFFF) {
                                localHeaderOffset = Number(cdView.getBigUint64(zip64Offset, true))
                            }
                            break
                        }
                        extraOffset += 4 + dataSize
                    }
                }
                
                const nameBytes = new Uint8Array(cdBuffer, offset + 46, nameLen)
                const fileName = new TextDecoder('utf-8').decode(nameBytes)
                
                if (fileName.endsWith('bid_info.json')) {
                    fileHeaderOffset = localHeaderOffset
                    compressedSize = compSize
                    uncompressedSize = uncompSize
                    compressionMethod = method
                    break
                }
                
                offset += 46 + nameLen + extraLen + commentLen
            }
            
            if (fileHeaderOffset === -1) {
                throw new Error('压缩包内未找到 bid_info.json 配置文件')
            }
            
            const realFileHeaderOffset = fileHeaderOffset + shift
            const localHeaderSize = 30 + 512
            const localHeaderBlob = file.slice(realFileHeaderOffset, realFileHeaderOffset + localHeaderSize)
            const localHeaderBuffer = await localHeaderBlob.arrayBuffer()
            const localHeaderView = new DataView(localHeaderBuffer)
            
            const signature = localHeaderView.getUint32(0, true)
            if (signature !== 0x03044b50) {
                console.error('ZIP 本地头签名错误:', signature.toString(16), 'Expected: 3044b50. Shift:', shift)
                throw new Error('无效的 ZIP 本地文件头')
            }
            
            const nameLen = localHeaderView.getUint16(26, true)
            const extraLen = localHeaderView.getUint16(28, true)
            const realDataOffset = realFileHeaderOffset + 30 + nameLen + extraLen
            
            const dataBlob = file.slice(realDataOffset, realDataOffset + compressedSize)
            
            let jsonText = ''
            if (compressionMethod === 0) {
                jsonText = await dataBlob.text()
            } else if (compressionMethod === 8) {
                if (typeof DecompressionStream !== 'undefined') {
                    const ds = new DecompressionStream('deflate-raw')
                    const decompressedStream = dataBlob.stream().pipeThrough(ds)
                    const response = new Response(decompressedStream)
                    jsonText = await response.text()
                } else {
                    throw new Error('当前浏览器不支持 DecompressionStream 气流解压')
                }
            } else {
                throw new Error('不支持的压缩格式: ' + compressionMethod)
            }
            
            return JSON.parse(jsonText)
        },
        // 移除已选文件
        removeBidDoc() {
            this.$confirm('确定移除该文件？', '提示', {
                type: 'warning',
                confirmButtonText: '确定',
                cancelButtonText: '取消'
            }).then(async () => {
                if (this.bidDocFile && this.bidDocFile.fileId) {
                    try {
                        await deleteBidAtt(this.bidDocFile.fileId)
                    } catch (e) {
                        console.error('删除文件失败:', e)
                    }
                }
                this.bidDocFile = null
                this.uploadFileId = ''
                this.bidDocUploadProgress = 0
            }).catch(() => { })
        },
        // 返回上一页
        handleBack() {
            this.$router.go(-1)
        },

        // 撤回
        handleWithdraw() {
            this.revokeBidDocument()
        },
        //撤销文件
        async revokeBidDocument() {
            const res = await revokeBidDocument({
                sectionCode: this.sectionCode
            })
            if (res.code == 200) {
                this.$message.success('撤销成功')
                setTimeout(() => {
                    this.handleBack()
                }, 1000);

            } else {
                this.$message.error(res.msg)
            }


        },

        // 查看回执 - 直接下载文件流
        async handleViewReceipt() {
            try {
                this.$message.info('正在下载回执文件...')
                const res = await downloadReceiptPdf({
                    sectionCode: this.sectionCode
                })
                // 处理文件流下载
                if (res) {
                    // 创建blob对象
                    const blob = new Blob([res], {
                        type: 'application/pdf'
                    })
                    // 创建下载链接
                    const url = window.URL.createObjectURL(blob)
                    const link = document.createElement('a')
                    link.href = url
                    link.download = `投标文件回执_${this.sectionCode}_${new Date().getTime()}.pdf`
                    // 触发下载
                    document.body.appendChild(link)
                    link.click()
                    // 清理
                    document.body.removeChild(link)
                    window.URL.revokeObjectURL(url)
                    this.$message.success('回执文件下载成功')
                } else {
                    this.$message.error('回执文件下载失败')
                }
            } catch (error) {
                console.error('下载回执文件错误:', error)
                this.$message.error('下载回执文件失败')
            }
        },
        // 从 URL 中提取文件名
        getDownloadFileName(url, defaultName) {
            try {
                const decoded = decodeURIComponent(url)
                const match = decoded.match(/filename=([^&"]+)/)
                if (match && match[1]) {
                    return match[1]
                }
            } catch (e) {
                console.error('解析文件名失败:', e)
            }
            return defaultName
        },
        // 下载文件
        async handleDownload(url, fileName) {
            try {
                this.$message.info('正在准备下载...')
                // 使用完整 URL 直接下载
                const link = document.createElement('a')
                link.href = url
                link.download = fileName || 'download'
                link.target = '_blank'
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                this.$message.success('下载成功')
            } catch (error) {
                console.error('下载文件错误:', error)
                this.$message.error('下载文件失败')
            }
        },

    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-child-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
}

.page-header-content {
    display: flex;
    flex-direction: column;
    text-align: start;
}

.header-action {
    text-align: end;
    flex-shrink: 0;
}

.page-subtitle {
    margin: 0;
    color: @gray-500;
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6;
}

.page-title {
    color: @gray-700;
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
}

.content-container {
    padding: 20px;
    border-radius: 8px;
    box-shadow: @shadow-sm;
    background: #fff;
    text-align: start;
    padding-bottom: 100px;
}

.info-card {
    background: @gray-50;
    border: 1px solid @gray-200;
    border-radius: 8px;
    margin-bottom: 24px;

    .card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 18px 20px;
        border-bottom: 1px solid @gray-200;

        i {
            font-size: 18px;
            color: @gray-500;
        }

        .card-title {
            flex: 1;
            font-size: 18px;
            font-weight: 600;
            color: @gray-700;
            margin: 0;
        }

    }

    .card-body {
        padding: 20px;
    }
}

.info-item-row {
    margin-bottom: 16px;

    &:last-child {
        margin-bottom: 0;
    }

    .info-label {
        display: block;
        font-size: 13px;
        color: @gray-500;
        margin-bottom: 8px;
        font-weight: 500;
    }

    .info-value {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 14px;
        color: @gray-700;
        padding: 10px 12px;
        background: #fff;
        border: 1px solid @gray-200;
        border-radius: 6px;
        min-height: 40px;

        i {
            color: @gray-500;
            font-size: 16px;
        }

        &.file-name {
            font-weight: 500;
            color: @gray-700;
        }

        &.code {
            font-family: 'Courier New', monospace;
            background: @gray-100;
            color: @gray-700;
        }
    }
}

.upload-trigger {
    border: 2px dashed @gray-300;
    border-radius: 8px;
    padding: 40px 20px;
    text-align: center;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;

    &:hover {
        border-color: @primary-color;
        background: fade(@primary-color, 4%);
    }

    .upload-trigger-icon {
        font-size: 48px;
        color: @gray-400;
        display: block;
        margin-bottom: 12px;
    }

    .upload-trigger-title {
        font-size: 15px;
        font-weight: 500;
        color: @gray-600;
        margin: 0 0 6px;
    }

    .upload-trigger-hint {
        font-size: 12px;
        color: @gray-400;
        margin: 0;

        strong {
            color: @gray-600;
        }

        &--warn {
            color: #e6a23c;
            margin-top: 6px;
        }
    }
}

.upload-file-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    background: @gray-50;
    border: 1px solid @gray-200;
    border-radius: 6px;

    &.read-only {
        background: #f0f9eb;
        border-color: #c2e7b0;
    }

    .upload-file-icon {
        font-size: 20px;
        color: @primary-color;
        flex-shrink: 0;
    }

    .upload-file-name {
        flex: 1;
        font-size: 14px;
        color: @gray-700;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .upload-file-progress {
        width: 180px;
        flex-shrink: 0;
    }

    .upload-file-remove {
        color: @error-color;
        padding: 0;
        flex-shrink: 0;

        i {
            margin-right: 4px;
        }
    }
}

.info-row.spacing-top {
    margin-top: 20px;
}


.info-notice {
    display: flex;
    align-items: center;
    gap: 12px;
    background: #fff;
    border: 1px solid @gray-200;
    border-left: 4px solid @gray-400;
    border-radius: 8px;
    padding: 12px 16px;
    margin-bottom: 20px;

    i {
        color: @gray-500;
        font-size: 18px;
        flex-shrink: 0;
    }

    span {
        color: @gray-600;
        font-size: 13px;
        line-height: 1.5;
    }
}

.file-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.file-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 16px;
    background: #fff;
    border: 1px solid @gray-200;
    border-radius: 8px;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:hover {
        border-color: @primary-color;
        box-shadow: 0 2px 8px fade(@gray-900, 4%);
    }

    .file-icon-wrap {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: fade(@primary-color, 8%);
        flex-shrink: 0;

        .file-icon {
            font-size: 20px;
            color: @primary-color;
        }
    }

    .file-info {
        flex: 1;
        min-width: 0;

        .file-name {
            font-size: 14px;
            font-weight: 500;
            color: @gray-700;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    .el-button {
        flex-shrink: 0;
    }
}

.form-field {
    margin-bottom: 20px;

    &:last-child {
        margin-bottom: 0;
    }

    .field-label {
        display: block;
        font-size: 14px;
        color: @gray-600;
        margin-bottom: 8px;
        font-weight: 500;

        &.required::before {
            content: '*';
            color: @error-color;
            margin-right: 4px;
        }
    }

    .el-input {
        width: 100%;
    }
}

/deep/ .el-input__inner {
    border-color: @gray-300;
    color: @gray-700;

    &:focus {
        border-color: @primary-color;
        box-shadow: 0 0 0 2px fade(@primary-color, 15%);
    }

    &::placeholder {
        color: @gray-400;
    }
}

.action-footer {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    margin-top: 32px;
    padding: 24px;
    background: #fff;
    border: 1px solid @gray-200;
    border-radius: 8px;

    .el-button {
        min-width: 140px;
        padding: 14px 28px;
        font-size: 15px;
        font-weight: 600;
        border-radius: 4px;
    }
}



@media (max-width: 768px) {
    .bidder-child-page {
        padding: 16px;
    }

    .page-header {
        flex-direction: column;
        align-items: stretch;
    }

    .header-action {
        text-align: left;
    }

    .page-title {
        font-size: 20px;
    }

    .content-container,
    .info-card .card-body,
    .info-card .card-header,
    .action-footer {
        padding-left: 16px;
        padding-right: 16px;
    }

    .info-card {
        .card-header {
            flex-wrap: wrap;
            gap: 8px;
        }
    }

    .action-footer {
        flex-direction: column;

        .el-button {
            width: 100%;
        }
    }
}
</style>
